module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-left-down-65a3c8d8860ff28fa79496e214d056c3.svg";